import React from 'react';
import '../../styles/GSIDA.css';
import programCover from '../../assets/img01.png'; // CIGSIDA 2025 Program Cover

export default function GSIDAProgram() {
  const openPdf = () => {
    // Placeholder PDF URL
    window.open('https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf', '_blank');
  };

  return (
    <div className="gsida-program-page">
      <div className="gsida-header-banner program-banner">
         <div className="banner-overlay">
            <h1>Programme Officiel</h1>
          
         </div>
      </div>

      <div className="gsida-content-container">


        <section className="program-display">

          <div className="section-header-v2">
            <span className="accent-line"></span>
            <h3>Découvrez l'agenda détaillé du Congrès GSIDA 2026</h3>
          </div>

           <div className="program-card-a4" onClick={openPdf}>
         
              <div className="program-sheet" style={{'backgroundImage': `url(${programCover})`}}>
              </div>
           </div>
           <div className="program-info">
      
           </div>
        </section>


      </div>
    </div>
  );
}
